











































































































































    import {Component, Vue, Mixins} from "vue-property-decorator";
import ConfigMixin from "../mixins/ConfigMixin";
import { Invoice, InvoiceService, PaymentService } from "../services/accounting.service";
import PaymentPortal from "../components/PaymentPortal.vue"

    @Component({
        components: {
            PaymentPortal,
        }
    })
    export default class InvoiceView extends Mixins(ConfigMixin) {

        private invoice: Invoice | null = null;
        private error: string | null = null;
        private paymentError: string | null = null;
        private loading: boolean = true;

        private processingPayment: boolean = false;

        private paymentAmount: number = 0;
        private paymentCardId: string = "";

        private api = new PaymentService();

        private async created() {
            const invoices = new InvoiceService();
            const res = await invoices.getOne(this.$route.params.id);

            if (res.success) {
                this.invoice = res.result;
                this.paymentAmount = this.totalAmount - res.result.amountPaid;
            } else {
                this.error = "Invoice does not exist";
            }

            this.loading = false;
        }

        private getName(): string {
            return this.getConfig('NAME');
        }

        private get nameStart(): string {
            const raw = this.getName();
            const parts = raw.split(' ');
            return parts.slice(0, parts.length - 1).join(' ');
        }

        private get nameEnd(): string {
            const raw = this.getName();
            const parts = raw.split(' ');
            return parts[parts.length - 1];
        }

        private get totalAmount(): number {
            if (!this.invoice) return 0;

            let sum = 0;

            for (const item of this.invoice.items) {
                sum += item.quantity * item.rate;
            }

            return sum;
        }

        gotoPayment() {
            // @ts-ignore
            this.$refs.portal.focus();
        }

        private setAmount(amount: number) {
            this.paymentAmount = amount;
        }

        private setToken(token: string) {
            this.paymentCardId = token;
        }

        async pay() {

            if (!this.invoice) {
                return;
            }

            this.processingPayment = true;
            try {
                const payment = await this.api.post({
                    cardId: this.paymentCardId,
                    amount: this.paymentAmount,
                    invoiceId: this.invoice.id
                });
                if (payment.success === true) {
                    this.$router.push({name: 'Payment', params: {id: payment.result.id}})
                } else {
                    this.paymentError = payment.error.message;
                }
                this.processingPayment = false;
            } catch (e) {
                this.processingPayment = false;
                this.paymentError = "An unknown error occurred. Please try again shortly."
            }
        }
    }
